import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { Event } from '../../../modules/analytics/components';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../../modules/analytics/components/Event';
import Modal from '../../../modules/foundation/components/Modal';
import { DEFAULT_MODAL_ANIMATION } from '../../../modules/foundation/components/Modal/Modal.constants';
import { ModalAnimationPropType } from '../../../modules/foundation/components/Modal/Modal.types';
import useSemanticUiProps from '../../../modules/foundation/hooks/use-semantic-ui-props';
import { LocationPropType, ObjectPropsPropType } from '../../../services/proptypes';
import CustomerReview from '../CustomerReview/CustomerReview';
import './CustomerReviewModal.css';
var defaultProps = {
  locations: [],
  showRating: true,
  animation: DEFAULT_MODAL_ANIMATION,
  triggerButtonProps: {
    primary: true
  },
  buttonText: 'Submit Review'
};
export default function CustomerReviewModal(_ref) {
  var businessId = _ref.businessId,
    locations = _ref.locations,
    showRating = _ref.showRating,
    businessType = _ref.businessType,
    animation = _ref.animation,
    triggerButtonProps = _ref.triggerButtonProps,
    buttonText = _ref.buttonText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  function showModal() {
    setOpen(true);
  }
  function closeModal() {
    setOpen(false);
  }
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  var buttonProps = getButtonProps(triggerButtonProps || {});
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    onOpen: showModal,
    open: open,
    dimmer: "inverted",
    className: "submit-reviews-modal",
    trigger: /*#__PURE__*/React.createElement("div", {
      className: "submit-review-button-container"
    }, /*#__PURE__*/React.createElement(Event, {
      eventType: "click",
      event: {
        category: EVENT_CATEGORIES.REVIEWS_EVENT_CATEGORY,
        action: EVENT_ACTIONS.REVIEWS_OPEN_SUBMIT_REVIEW_MODAL_EVENT_ACTION
      }
    }, /*#__PURE__*/React.createElement(Button, _extends({
      content: buttonText
    }, buttonProps, {
      onClick: showModal
    })))),
    size: "small",
    animation: animation
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", null, "Write a Review"), /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    onClick: closeModal
  })), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(CustomerReview, {
    businessId: businessId,
    businessType: businessType,
    locations: locations,
    showRating: showRating
  })));
}
CustomerReviewModal.defaultProps = defaultProps;